/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';
import styles from './TwitterIcon.style';

import svg from './twitter.svg';

type Props = {
  className?: string,
  title?: string,
};

const useStyles = createUseStyles(styles);

const TwitterIcon = ({ className, title }: Props): React.Node => {
  const classes: Object = useStyles();

  return (
    <BaseIcon
      className={classNames(classes.root, className)}
      svg={svg}
      title={title}
    />
  );
};

export default compose(React.memo)(TwitterIcon);
